module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view view-single-winner",
    attrs: {
      "id": "spot"
    }
  }, [_c('div', {
    staticClass: "content",
    attrs: {
      "id": "browse"
    }
  }, [_c('div', {
    staticClass: "inside-closer",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("✖")]), _vm._v(" "), _c('div', {
    staticClass: "sub-heading padding-20"
  }, [_vm._v("Uställare 2017")]), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_vm._v("Exhibition Stockholm")]), _vm._v(" "), _c('div', {
    staticClass: "sub-heading padding-40 pad-sides"
  }, [_vm._v("\n      " + _vm._s(_vm.photographer) + "\n    ")]), _vm._v(" "), (_vm.photosLoaded === true) ? _c('div', {
    staticStyle: {
      "padding": "15px 0px"
    }
  }, [_c('photoFeed', {
    attrs: {
      "photos": _vm.winnerPhotos,
      "show-user": "true"
    }
  }, [_c('div', {
    slot: "empty"
  }, [_vm._v("Något gick fel, prova ladda om sidan!")])])], 1) : _c('div', [_c('loader', {
    attrs: {
      "colorClass": "black"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dbd38be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/singleFeed.vue
// module id = 108
// module chunks = 0